export default __webpack_public_path__ + "static/media/MAXUS.bdf77b20.png";